import styled from 'styled-components';

import ConfigurableModal from '~organisms/ConfigurableModal';

export const Container = styled(ConfigurableModal)(({ theme }) => ({
  '& .ant-modal-title': {
    fontSize: theme.typography.size24,
    color: theme.palette.artichoke,
    fontWeight: 'bold',
    fontFamily: theme.typography.family.arial,
  },
  '& .ant-modal-content': {
    maxWidth: '600rem',
    padding: '30rem',
  },

  '& .ant-modal-footer': {
    display: 'flex',
    justifyContent: 'flex-end',

    '& button': {
      fontSize: theme.typography.size20,
      marginTop: '25rem',
    },
  },

  '& .modal-content': {
    justifyContent: 'flex-start',
    fontSize: theme.typography.size16,
    marginTop: '26rem',
    fontFamily: theme.typography.family.arial,
    color: theme.palette.erieBlack,
  },
}));
